import React, { useState } from 'react';
import { TextField, InputAdornment } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import { ITextInputWithFormat } from './interface';

const TextInputWithFormat: React.FC<ITextInputWithFormat> = ({
  field,
  form,
  suffix,
  prefix,
  helperText = '',
  thousandSeparator = '.',
  decimalSeparator = ',',
  decimalScale = 2,
  fixedDecimalScale = true,
  type = 'text',
  showErrorText = true,
  ...props
}: ITextInputWithFormat) => {
  const { name } = field;
  const { setFieldValue, getFieldMeta } = form;
  const { value, touched, error } = getFieldMeta(name);

  const [focused, setFocused] = useState<boolean>(false);

  const handleOnFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    props.onFocus && props.onFocus(e);
    setFocused(true);
  };

  const handleOnBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    props.onBlur && props.onBlur(e);
    field.onBlur && field.onBlur(e);
    setFocused(false);
  };

  return (
    <NumberFormat
      fullWidth
      onValueChange={(values) => {
        const newValue =
          (type as string) === 'number' ? values.floatValue : values.value;

        if (newValue !== value) {
          setFieldValue(name, newValue);
        }
      }}
      customInput={TextField}
      mask="_"
      {...field}
      onChange={undefined}
      error={touched && !!error}
      suffix={undefined}
      preffix={undefined}
      thousandSeparator={thousandSeparator}
      decimalSeparator={decimalSeparator}
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      InputProps={{
        startAdornment: prefix && (
          <InputAdornment position="start">{prefix}</InputAdornment>
        ),
        endAdornment: suffix && (
          <InputAdornment position="end">{suffix}</InputAdornment>
        ),
      }}
      {...props}
      onFocus={handleOnFocus}
      onBlur={handleOnBlur}
      FormHelperTextProps={{
        title: (showErrorText && error) || (focused ? helperText : ''),
        ...props.FormHelperTextProps,
      }}
      helperText={
        (touched && showErrorText && error) ||
        (helperText && focused ? helperText : ' ')
      }
    />
  );
};

export default TextInputWithFormat;
